import React from "react";
import { Link } from "react-router-dom";
import LogoProyecto from "../UI/svg/logo-proyecto.svg";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { MAQUETA_ROUTE } from "./../config/routes";

import { ContextLoader } from "./../utils/import.frames";

import {
  initialProyectosWelcome,
  cachedImagesWelcome,
  loadedImagesWelcome,
  stepWelcome,
  loadingWelcome,
  ingresoWelcome,
} from "../redux/actions";

import BienvenidoContainer from "./../container/bienvenidoContainer";

//TODO: Move all caching / preloading logic to another component - controller

class Ingreso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const section = document.querySelector("section");

    this.general = ContextLoader["General View"]();

    this.torre1 = ContextLoader["Torre A Ovalada"]();

    this.images = [
      this.general[0],
      this.general[6],
      this.general[12],
      this.general[18],
      this.general[24],
      this.general[30],
      this.general[36],
      this.general[42],
      this.general[48],
      this.general[54],
      this.general[60],
      this.general[66],

      this.torre1[0],
      this.torre1[6],
      this.torre1[12],
      this.torre1[18],
      this.torre1[24],
      this.torre1[30],
      this.torre1[36],
      this.torre1[42],
      this.torre1[48],
      this.torre1[54],
      this.torre1[60],
      this.torre1[66],
    ];

    this.images.forEach((src) => {
      new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;

        /* var stateCopy = Object.assign({}, this.state);
        stateCopy.cache[src] = img;
        this.setState(stateCopy); */

        img.onload = (event) => {
          this.props.loadedImagesWelcome(this.props.loadedImages + 1);
          if (this.props.loadedImages === this.images.length) {
            
            setTimeout(()=>{
              this.props.cachedImagesWelcome(true);
              this.props.loadingWelcome(true);
              this.props.ingresoWelcome(true);
            }, 500)
            
            /* this.handleWelcomeMessage(); */
          }
        };
        img.onerror = (err) => {
          reject();
        };
      }).catch((e) => {
        console.log("[cache error]:", e);
      });
    });

    //LOADING MATERIAL
    this.props.initialProyectosWelcome();
  }

  render() {
    let {
      loaded,
      welcome,
      cachedImages,
      proyecto,
      textures,
      loadedImages,
      step,
    } = this.props;
    return (
      <div
        className={!welcome ? "loading-page" : "loading-page fixed swap-image"}
      >
        <BienvenidoContainer
          loaded={loaded}
          cachedImages={cachedImages}
          welcome={welcome}
          proyecto={proyecto}
          loadedImages={loadedImages}
        />

        <div
          className={
            welcome ? "ingreso-container fixed" : "ingreso-container fadeOut"
          }
        >
          <div className="row px-4 pl-2 ">
            <div className="col-md-12 aling-center">
              <img className="logo-proyecto-large" alt="" src={LogoProyecto} />
            </div>
            {
            /*<div className="script-task">Agregar Script de Yandex</div>*/
            }
            <div className="col-md-12 aling-justify">
              <p>
              Las imágenes publicadas, planos, renders y demás piezas publicitarias son representaciones digitales del diseño y junto con el apartamento modelo exhibido en la sala de ventas, pueden variar en su percepción y construcción final y están sujetos a modificación y cambios sin previo aviso o consulta, por lo tanto, no constituyen oferta por parte del promotor y/o constructor. 
              </p>
            </div>
            <div className="col-md-12 aling-justify">
              <p>
              Las áreas comunes amobladas corresponden a imágenes de referencia, que no hacen parte de la oferta comercial, las mismas están sujetas a modificación y cambios discrecionales sin previo aviso o consulta por parte del constructor, conservando las características de calidad, seguridad e idoneidad. 
              </p>
            </div>
            <br></br>
            
            <div className="col-md-12 aling-justify">
              <p>
                
              </p>
            </div>
            <div className="col-md-12 aling-center">
            {
            welcome ? 
            <Link
                to={{
                  pathname: MAQUETA_ROUTE,
                  state: {
                    propsProyecto: proyecto,
                    propsTextures: textures,
                  },
                }}
                className="btn_ingreso"
              >
                <span>Ingresar</span>
              </Link>
              :
              null
            }
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ welcomeReducer }) => {
  const {
    loaded,
    welcome,
    cachedImages,
    proyecto,
    textures,
    loadedImages,
    step,
  } = welcomeReducer;
  return {
    loaded,
    welcome,
    cachedImages,
    proyecto,
    textures,
    loadedImages,
    step,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    initialProyectosWelcome,
    cachedImagesWelcome,
    loadedImagesWelcome,
    stepWelcome,
    loadingWelcome,
    ingresoWelcome
  })(Ingreso)
);
